


















































import { Vue, Component } from 'vue-property-decorator'
import PStorage, { SECRET_KEY } from '@/util/PStorage'
import { downloadFile } from '@/util/Helpers'

import SettingsHeader from '../components/SettingsHeader.vue'
import SettingsSection from '../components/SettingsSection.vue'
import SettingsRow from '../components/SettingsRow.vue'

@Component({ name: 'keys-panel', components: { SettingsHeader, SettingsSection, SettingsRow } })
export default class KeysPanel extends Vue {
    /**
     * Secret key from storage
     */
    secretKey: string = PStorage.get(SECRET_KEY)

    /**
     * Secret key split into sections
     */
    get splitSecretKey(): string[] {
        return this.secretKey.split('-')
    }

    /**
     * Download the secret key
     */
    downloadKey(): void {
        downloadFile('volt-secret.txt', this.secretKey)
    }
}
